/**
 * @fileoverview `useLegalContentTranslate()` — the legal-page chrome's translator, bound from the ONE
 * shared factory (`@puffin-core/i18n-bootstrap/namespace-translate`).
 * @package @puffin-core/legal-content
 *
 * Resolution order: the `legalContent` namespace (namespace #56, registered at boot by
 * `@puffin-core/i18n-namespaces`) → the English bundle, so an unwired tree renders readable English
 * rather than a raw key. `{{double}}` braces, `keep` on a missing value — the same template i18next
 * interpolates, and an unsupplied placeholder stays VISIBLE rather than blanking.
 *
 * It words the CHROME only; a document's own words are the registry's, in `LEGAL_DOCUMENT_LANGUAGE`.
 * Every element worded through it carries `lang={t('chromeLanguage')}`.
 *
 * ⚠️ Hook placement: call it immediately above the first hook or expression that consumes it
 * (`web/component-state-order`).
 *
 * @module @puffin-core/legal-content/hooks/useLegalContentTranslate
 */

import { createInterpolator } from '@puffin-core/i18n-bootstrap/strings-kit';
import { createNamespaceTranslate } from '@puffin-core/i18n-bootstrap/namespace-translate';

import { LEGAL_CONTENT_NAMESPACE } from '../strings/namespace.js';
import { resolveString } from '../strings/resolveString.js';

export const useLegalContentTranslate = createNamespaceTranslate({
  namespace: LEGAL_CONTENT_NAMESPACE,
  resolveString,
  interpolate: createInterpolator({ braces: 'double', onMissing: 'keep' }),
});

export default useLegalContentTranslate;
